import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_GET_CONTACTS_ITEM_SERVER } from '@/app/module/contacts/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetContact = (id: number) => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getContact.useQuery(
    { orgId: orgId.toString(), contactId: id.toString() },
    { skip: !orgId || !id },
  )

  useEffect(() => {
    if (!res.error) {
      return
    }

    dispatch(
      createNotification({
        'get-contacts': {
          type: 'error',
          message: ERROR_GET_CONTACTS_ITEM_SERVER,
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
